import { 
  getDatabase, 
  ref, 
  onValue, 
  onDisconnect,
  set,
  serverTimestamp,
  push,
  remove
} from 'firebase/database';
import app from '../firebase';

class OnlineUsersService {
  private static instance: OnlineUsersService | null = null;
  private db;
  private userRef: any = null;
  private onlineCountCallback: ((count: number) => void) | null = null;
  private isConnected: boolean = false;
  
  private constructor() {
    this.db = getDatabase(app);
  }
  
  public static getInstance(): OnlineUsersService {
    if (!OnlineUsersService.instance) {
      OnlineUsersService.instance = new OnlineUsersService();
    }
    return OnlineUsersService.instance;
  }
  
  // Start tracking this user as online
  public startTracking(): void {
    if (this.isConnected) return;
    
    try {
      // Create a reference for this user
      const onlineUsersRef = ref(this.db, 'onlineUsers');
      this.userRef = push(onlineUsersRef);
      
      // Set user as online with timestamp
      set(this.userRef, {
        timestamp: serverTimestamp(),
        userAgent: navigator.userAgent.substring(0, 100) // Truncate for storage
      });
      
      // Remove user when they disconnect
      onDisconnect(this.userRef).remove();
      
      this.isConnected = true;
      console.log('Started tracking online presence');
    } catch (error) {
      console.warn('Failed to start online tracking:', error);
    }
  }
  
  // Listen for changes in online user count
  public subscribeToOnlineCount(callback: (count: number) => void): void {
    this.onlineCountCallback = callback;
    
    try {
      const onlineUsersRef = ref(this.db, 'onlineUsers');
      
      onValue(onlineUsersRef, (snapshot) => {
        const data = snapshot.val();
        const count = data ? Object.keys(data).length : 0;
        
        if (this.onlineCountCallback) {
          this.onlineCountCallback(count);
        }
      });
    } catch (error) {
      console.warn('Failed to subscribe to online count:', error);
      // Return 0 on error
      if (this.onlineCountCallback) {
        this.onlineCountCallback(0);
      }
    }
  }
  
  // Stop tracking this user
  public stopTracking(): void {
    if (this.userRef) {
      remove(this.userRef);
      this.userRef = null;
      this.isConnected = false;
    }
  }
}

export default OnlineUsersService;